module.exports = __webpack_public_path__ + "static/media/program_empty_image.2e1027bd.jpg";